import { set } from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import { fetchSettings } from '../../sagas/routines';

const initialState = {
  data: {},
  fetching: false,
  fetched: false,
  fetchingError: null
};

export const fetchSettingsHandler = routine => ({
  [routine.TRIGGER]: state => ({
    ...state,
    fetching: true,
    fetched: false
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('data', response, state),
  [routine.FAILURE]: (state, { error }) => set('fetchingError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

export default createReducer(initialState, {
  ...fetchSettingsHandler(fetchSettings)
});
